import APIClient from './index';

export const fetchWebinars = () => APIClient.get('Webinars').then(r => r.data.webinars);

export const fetchWebinarTopics = () => APIClient.get('Webinars/topics').then(r => r.data.topics);

export const createWebinar = payload => APIClient.post('Webinars', payload).then(r => r.data.webinar);

export const updateWebinar = (id, payload) => APIClient.put(`Webinars/${id}`, payload).then(r => r.data.webinar);

export const deleteWebinar = id => APIClient.delete(`Webinars/${id}`).then(r => r.data);
